import Enum from 'enum';

export const Resources = new Enum({
  Downloads: 'downloads',
  DownloadDocument: 'downloads/:documentId',
  DownloadDocuments: 'downloads',
});
